import axios from 'axios';
import { requestScheduleItemsAmountQuery } from './queries';
import { buildExpressQuery, buildLoopbackQuery } from './queries/builders';
import Split from '../split';

const requestScheduleItemsAmount = async (key) => {
    try {
        const useExpress = Split.getBooleanTreatment('use_express_migration_endpoints');
        const queryBuilder = useExpress ? buildExpressQuery : buildLoopbackQuery;
        const query = requestScheduleItemsAmountQuery({ key, queryBuilder });
        const request = axios.patch(query.url, { ...query.body });
        const { data } = await request;
        return { items: data };
    } catch {
        throw new Error('Unable to edit schedule item');
    }
};

export default requestScheduleItemsAmount;
